<div class="modal-content">
  <div class="modal modal-body">
    <div class="modal__header">
      <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="close()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <img src="assets/images/verify-safe-error.png" width="120" alt="seguranca">
    
    <div class="modal__message"> Oops, parece que os números digitados não correspondem com o seu <strong>Código de Segurança</strong>.</div>
    
    <div class="modal__action">
      <app-gradient-button
        label="DIGITAR NOVAMENTE"
        (click)="onClickConfirm()">
      </app-gradient-button>
    </div>
  </div>
</div>

